(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mak-car-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mkc-photo-gallery')){
  customElements.define('mkc-photo-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.items=Array.from(this.querySelectorAll('[data-photo]'));
      if(!this.items.length)return;
      this.initialized=true;this.index=0;this.dialog=this.querySelector('dialog');this.swipedAt=0;
      this.addEventListener('click',event=>{
        if(!(event.target instanceof Element))return;
        const button=event.target.closest('button');if(!button)return;
        if(button.hasAttribute('data-open')){if(Date.now()-this.swipedAt<400)return;this.openViewer(button);}
        else if(button.hasAttribute('data-close'))this.dialog.close();
        else if(button.hasAttribute('data-prev'))this.select(this.index-1);
        else if(button.hasAttribute('data-next'))this.select(this.index+1);
        else if(button.hasAttribute('data-index'))this.select(Number(button.dataset.index));
      });
      this.addEventListener('keydown',event=>{
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.select(this.index+(event.key==='ArrowRight'?1:-1));}
        if(event.key==='Home'){event.preventDefault();this.select(0);}
        if(event.key==='End'){event.preventDefault();this.select(this.items.length-1);}
      });
      this.querySelectorAll('[data-stage]').forEach(stage=>{
        let start=null;
        stage.addEventListener('dragstart',event=>event.preventDefault());
        stage.addEventListener('pointerdown',event=>{if(!event.isPrimary||event.button!==0)return;start={x:event.clientX,y:event.clientY,id:event.pointerId};});
        stage.addEventListener('pointerup',event=>{if(!start||start.id!==event.pointerId)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4){this.swipedAt=Date.now();this.select(this.index+(dx<0?1:-1));}});
        stage.addEventListener('pointercancel',()=>{start=null;});
      });
      this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.opener?.focus({preventScroll:true});});
      this.select(0);
    }
    select(next){
      this.index=(next+this.items.length)%this.items.length;
      const item=this.items[this.index];
      this.querySelectorAll('.mkg-image,.mkg-large').forEach(img=>{img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=item.dataset.src;img.alt=item.dataset.alt;});
      this.querySelectorAll('[data-index]').forEach(button=>{const selected=Number(button.dataset.index)===this.index;if(selected)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
      const counter=String(this.index+1).padStart(2,'0')+' / '+String(this.items.length).padStart(2,'0');
      this.querySelectorAll('[data-count]').forEach(label=>{label.textContent=counter;});
      this.querySelector('[data-announcement]').textContent=item.getAttribute('aria-label');
      this.querySelectorAll('.mkg-strip').forEach(strip=>{const selected=strip.querySelector('[aria-current="true"]');if(!selected)return;const left=selected.offsetLeft-strip.offsetLeft-(strip.clientWidth-selected.offsetWidth)/2;strip.scrollTo({left,behavior:'instant'});});
      if(this.items.length>1){const preload=new Image();preload.src=this.items[(this.index+1)%this.items.length].dataset.src;}
    }
    openViewer(button){this.opener=button;this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.querySelector('[data-close]').focus({preventScroll:true});this.select(this.index);}
    disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow||'';}}
  });
}
  } catch(e) { console.error(e); }
})();

})();
